import { AddIconButton, Button } from '@library/components/buttons';
import {
  PlayerImage,
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import type { LeagueTeamPlayer } from '@library/types/player';
import playerSelected from '@library/assets/images/icons/purple-checked-icon.svg';

export interface AddPlayerProps {
  player: LeagueTeamPlayer;
  onAddPlayer: (player: LeagueTeamPlayer) => void;
  onRemovePlayer: (player: LeagueTeamPlayer) => void;
  playerAdded?: boolean;
}

export const AddPlayer = ({
  onAddPlayer,
  onRemovePlayer,
  player,
  playerAdded = false
}: AddPlayerProps) => {
  const { image_url: imageUrl = '', name, position = '', team = '' } = player;
  const positionDisplayValue = team ? `${position} • ${team}` : position;

  return (
    <div className="bg-soFresh-110 flex h-[49px] w-full items-center justify-between self-stretch">
      <PlayerProfile
        className="flex size-full items-center gap-4 self-stretch"
        imageUrl={imageUrl}
        name={name}
        subheader={positionDisplayValue}
      >
        <PlayerImage className="bg-soFresh-120 size-[49px] rounded-lg" />

        <div className="border-soFresh-110 flex h-10 flex-col items-start justify-start gap-2">
          <PlayerName className="font-heebo text-soClean-100 text-center text-sm font-medium leading-tight tracking-tight" />
          <PlayerSubheader className="text-soClean-170 font-heebo text-xs font-medium leading-[19px] tracking-tight" />
        </div>
      </PlayerProfile>
      {playerAdded ? (
        <Button
          className="size-10 shrink-0"
          onClick={() => {
            onRemovePlayer(player);
          }}
        >
          <img src={playerSelected} alt="Player Added" />
        </Button>
      ) : (
        <AddIconButton
          onClick={() => {
            onAddPlayer(player);
          }}
        />
      )}
    </div>
  );
};
